import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function Field({ label, hint, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label className="text-xs font-medium text-slate-700">{label}</Label>
      {children}
      {hint && <p className="text-[11px] text-slate-500">{hint}</p>}
    </div>
  );
}

export function TextField({ label, hint, value, onChange, placeholder, testId, multiline, rows = 3, className }) {
  return (
    <Field label={label} hint={hint} className={className}>
      {multiline
        ? <Textarea rows={rows} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="bg-white" />
        : <Input value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="bg-white" />}
    </Field>
  );
}

export function ChoiceCard({ active, onClick, title, text, icon: Icon, testId, multi = false }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId} aria-pressed={active} data-active={active ? "true" : "false"}
      className={`relative text-left rounded-xl border p-4 transition-[border-color,background-color,box-shadow] ${active ? "border-sky-500 bg-sky-50/60 ring-1 ring-sky-500" : "border-slate-200 bg-white hover:border-slate-300"}`}>
      {multi && <span aria-hidden className={`absolute right-3 top-3 flex h-4 w-4 items-center justify-center rounded border ${active ? "border-sky-600 bg-sky-600 text-white" : "border-slate-300 bg-white"}`}>{active && <Check size={11} strokeWidth={3} />}</span>}
      {Icon && <Icon size={18} className={active ? "text-sky-700" : "text-slate-500"} />}
      <p className={`text-sm font-semibold ${Icon ? "mt-3" : ""} text-slate-900`}>{title}</p>
      {text && <p className="mt-1 text-xs text-slate-500 leading-relaxed">{text}</p>}
    </button>
  );
}
